// extracted by mini-css-extract-plugin
export default {"formattedNumber":"oBvSkSm5JcfRJwaRCYg1"};